module.exports = __webpack_public_path__ + "img/logo3.7d58f9a7.png";